import { ElementRef, Injectable } from '@angular/core';

import { PopupPosition } from '../models/PopupPosition';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  constructor() {}
  getVariableCSS(name: string): string {
    return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  }
  isNullOrEmpty(value: unknown): boolean {
    return !value || Reflect.get(Object(value), 'length') === 0;
  }
  calculateAsciiCode(value: string): number {
    return this.isNullOrEmpty(value)
      ? -1
      : value
          .split('')
          .map((letter) => letter.charCodeAt(0))
          .reduce((previous, current) => previous + current);
  }
  newGuid(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (item) {
      // tslint:disable-next-line: one-variable-per-declaration
      const randomValue = (Math.random() * 16) | 0,
        result = item == 'x' ? randomValue : (randomValue & 0x3) | 0x8;
      return result.toString(16);
    });
  }
  encodeUTF8(value: string): string {
    return unescape(encodeURIComponent(value));
  }
  decodeUTF8(value: string): string {
    return decodeURIComponent(escape(value));
  }
  convertToClrPosition(position: PopupPosition): string {
    switch (position) {
      case PopupPosition.BottomLeft:
        return 'bottom-left';
      case PopupPosition.BottomRight:
        return 'bottom-right';
      case PopupPosition.TopLeft:
        return 'top-left';
      case PopupPosition.TopRight:
        return 'top-right';
    }
  }
  getParentBySelector(element: ElementRef<HTMLElement>, selector: string): Element | null {
    if (!this.isNullOrEmpty(selector)) {
      const foundElement = element.nativeElement.closest(selector);
      if (foundElement) {
        return foundElement;
      }
    }
    return null;
  }

  getScrollParent(element: Element): Element | null {
    const style = getComputedStyle(element);

    if (
      style.overflowY === 'auto' ||
      style.overflowY === 'visible' ||
      style.overflowY === 'overlay'
    ) {
      return element;
    }
    if (element.parentElement === null) {
      return null;
    } else {
      return this.getScrollParent(element.parentElement);
    }
  }
}
